import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AddButton, EditWithIcon, MinLoader, UploadModal } from 'components';
import { CustomDeleteModal } from 'fragments';
import { AddResource } from './addResource';
import { FindLoad, Images, PermissionsList, RolePermission, useModal } from 'utils';
import { resourceActions } from 'store';

const DELETE_RESOURCE = 'DELETE_RESOURCE';
const ACTION_TYPE = 'EDIT_RESOURCE_ACCESS';

export const SingleResourceHeader = ({ generatePayload, resetByDefault, disabled, setDisabled }) => {
  const { resourceById } = useSelector((state) => (
    {
      resourceById: state.resource.resourceById,
    }
  ));

  const { open } = useModal();
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const loading = FindLoad(ACTION_TYPE);
  const info = history?.location?.state;
  const currentId = params?.id;
  const onResource = 'resource';
  const uploadAccess = RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) || resourceById?.adminAccess?.upload;


  const handleActions = (name) => {
    if (name === 'edit') {
      open(<AddResource info={resourceById} />);
    }
    if (name === 'delete') {
      open(
        <CustomDeleteModal
          text="Are you sure you want to delete this folder? This action is not reversible."
          info="Folder"
          handleDel={() => dispatch(resourceActions.deleteResource(resourceById?.id))}
          actionType={DELETE_RESOURCE}
          innerText={'Delete'}
          afterSuccess={() => {
            history.push('/resource');
          }}
        />,
      );
    }
  };

  const handleClick = () => {
    open(
      <UploadModal
        currentId={currentId}
        onResource={onResource}
      />,
    );
  };

  return (
    <div className="single-resource-another-header">
      {resourceById?.name &&
        <p className="single-resource-another-header-file-name">
          {resourceById?.name}
        </p>
      }

      <div className="flex-align-center" style={{ gap: 10 }}>
        {(!info?.activeTab || info?.activeTab === 'Files') ?
          !!uploadAccess &&
          <AddButton handleClick={handleClick} text={'Upload Document'} />
          :
          <div className="flex-end">
            {disabled ?
              <button
                onClick={() => setDisabled(false)}
                className="reset-btn edit-access-btn"
              >
                <img src={Images.editNew} alt="edit" />
                <p>Edit Access</p>
              </button>
              :
              <div className="flex-align-center" style={{ gap: 10 }}>
                <button
                  className="reset-btn cancel-access-btn"
                  onClick={() => {
                    setDisabled(true);
                    resetByDefault();
                  }}
                >
                  Cancel
                </button>

                <button
                  onClick={generatePayload}
                  className="reset-btn edit-access-btn"
                  style={{ width: '60px' }}
                >
                  {loading?.length ?
                    <MinLoader
                      margin={'0'}
                      width={'14px'}
                      height={'14px'}
                      color={'#FFF'}
                      position={'relative'}
                    />
                    :
                    <p>Save</p>
                  }
                </button>
              </div>
            }
          </div>
        }
        {RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) &&
          <div className="grey-line" />
        }
        {RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) &&
          <EditWithIcon
            stylesIcon={{ filter: 'brightness(0) saturate(100%) invert(21%) sepia(6%) saturate(3250%) hue-rotate(181deg) brightness(96%) contrast(96%)' }}
            handleClick={() => handleActions('edit')}
          />
        }

        {RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) &&
          <EditWithIcon handleClick={() => handleActions('delete')} icon={Images.trashNew} />
        }
      </div>
    </div>
  );
};
